import * as ambassadorWixRestaurantsOperationsV1Operation from './restaurants-operations-v1-operation-operations.http.js';
import * as ambassadorWixRestaurantsOperationsV1OperationTypes from './restaurants-operations-v1-operation-operations.types.js';
import * as ambassadorWixRestaurantsOperationsV1OperationUniversalTypes from './restaurants-operations-v1-operation-operations.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listBlockedPeriods(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.ListBlockedPeriodsRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.ListBlockedPeriodsRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.ListBlockedPeriodsResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.ListBlockedPeriodsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.listBlockedPeriods(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/operation-pacing/blocked-periods',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getOperation(): __PublicMethodMetaInfo<
  'GET',
  { operationId: string },
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.GetOperationRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.GetOperationRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.GetOperationResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.GetOperationResponse
> {
  const payload = { operationId: ':operationId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.getOperation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/operations/{operationId}',
    pathParams: { operationId: 'operationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateOperation(): __PublicMethodMetaInfo<
  'PATCH',
  { operationId: string },
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.UpdateOperationRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.UpdateOperationRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.UpdateOperationResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.UpdateOperationResponse
> {
  const payload = { operation: { id: ':operationId' } } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.updateOperation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/operations/{operation.id}',
    pathParams: { operationId: 'operationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteOperation(): __PublicMethodMetaInfo<
  'DELETE',
  { operationId: string },
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.DeleteOperationRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.DeleteOperationRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.DeleteOperationResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.DeleteOperationResponse
> {
  const payload = { operationId: ':operationId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.deleteOperation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/operations/{operationId}',
    pathParams: { operationId: 'operationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryOperation(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.QueryOperationRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.QueryOperationRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.QueryOperationResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.QueryOperationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.queryOperation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/operations/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listOperations(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.ListOperationsRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.ListOperationsRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.ListOperationsResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.ListOperationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.listOperations(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/operations',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listAvailableFulfillmentOptions(): __PublicMethodMetaInfo<
  'GET',
  { operationId: string },
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.ListAvailableFulfillmentOptionsRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.ListAvailableFulfillmentOptionsRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.ListAvailableFulfillmentOptionsResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.ListAvailableFulfillmentOptionsResponse
> {
  const payload = { operationId: ':operationId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.listAvailableFulfillmentOptions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/operations/{operationId}/available-fulfillment-options',
    pathParams: { operationId: 'operationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listFirstAvailableTimeSlotForFulfillmentTypes(): __PublicMethodMetaInfo<
  'GET',
  { operationId: string },
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.ListFirstAvailableTimeSlotForFulfillmentTypesRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.ListFirstAvailableTimeSlotForFulfillmentTypesRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.ListFirstAvailableTimeSlotForFulfillmentTypesResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.ListFirstAvailableTimeSlotForFulfillmentTypesResponse
> {
  const payload = { operationId: ':operationId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.listFirstAvailableTimeSlotForFulfillmentTypes(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/operations/{operationId}/first-available-time-slot-for-fulfillment-types',
    pathParams: { operationId: 'operationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function calculateFirstAvailableTimeSlotPerFulfillmentType(): __PublicMethodMetaInfo<
  'GET',
  { operationId: string },
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.CalculateFirstAvailableTimeSlotPerFulfillmentTypeRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.CalculateFirstAvailableTimeSlotPerFulfillmentTypeRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.CalculateFirstAvailableTimeSlotPerFulfillmentTypeResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.CalculateFirstAvailableTimeSlotPerFulfillmentTypeResponse
> {
  const payload = { operationId: ':operationId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.calculateFirstAvailableTimeSlotPerFulfillmentType(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/operations/{operationId}/first-available-time-slot-per-fulfillment-type',
    pathParams: { operationId: 'operationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listFirstAvailableTimeSlotsForOperations(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.ListFirstAvailableTimeSlotsForOperationsRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.ListFirstAvailableTimeSlotsForOperationsRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.ListFirstAvailableTimeSlotsForOperationsResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.ListFirstAvailableTimeSlotsForOperationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.listFirstAvailableTimeSlotsForOperations(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/operations/first-available-time-slots-for-operations',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function calculateFirstAvailableTimeSlotsPerOperation(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.CalculateFirstAvailableTimeSlotsPerOperationRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.CalculateFirstAvailableTimeSlotsPerOperationRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.CalculateFirstAvailableTimeSlotsPerOperationResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.CalculateFirstAvailableTimeSlotsPerOperationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.calculateFirstAvailableTimeSlotsPerOperation(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/operations/first-available-time-slots-per-operations',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listFirstAvailableTimeSlotsForMenus(): __PublicMethodMetaInfo<
  'GET',
  { operationId: string },
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.ListFirstAvailableTimeSlotsForMenusRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.ListFirstAvailableTimeSlotsForMenusRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.ListFirstAvailableTimeSlotsForMenusResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.ListFirstAvailableTimeSlotsForMenusResponse
> {
  const payload = { operationId: ':operationId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.listFirstAvailableTimeSlotsForMenus(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/operations/{operationId}/first-available-time-slots-for-menus',
    pathParams: { operationId: 'operationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function calculateFirstAvailableTimeSlotsPerMenu(): __PublicMethodMetaInfo<
  'GET',
  { operationId: string },
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.CalculateFirstAvailableTimeSlotsPerMenuRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.CalculateFirstAvailableTimeSlotsPerMenuRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.CalculateFirstAvailableTimeSlotsPerMenuResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.CalculateFirstAvailableTimeSlotsPerMenuResponse
> {
  const payload = { operationId: ':operationId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.calculateFirstAvailableTimeSlotsPerMenu(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/operations/{operationId}/first-available-time-slots-per-menus',
    pathParams: { operationId: 'operationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function calculateFirstAvailableTimeSlotsForItem(): __PublicMethodMetaInfo<
  'GET',
  { operationId: string },
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.CalculateFirstAvailableTimeSlotsForItemRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.CalculateFirstAvailableTimeSlotsForItemRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.CalculateFirstAvailableTimeSlotsForItemResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.CalculateFirstAvailableTimeSlotsForItemResponse
> {
  const payload = { operationId: ':operationId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.calculateFirstAvailableTimeSlotsForItem(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/operations/{operationId}/first-available-time-slots-per-item',
    pathParams: { operationId: 'operationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listAvailableTimeSlotsForDate(): __PublicMethodMetaInfo<
  'GET',
  { operationId: string },
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.ListAvailableTimeSlotsForDateRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.ListAvailableTimeSlotsForDateRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.ListAvailableTimeSlotsForDateResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.ListAvailableTimeSlotsForDateResponse
> {
  const payload = { operationId: ':operationId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.listAvailableTimeSlotsForDate(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/operations/{operationId}/available-time-slots-for-date',
    pathParams: { operationId: 'operationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function calculateAvailableTimeSlotsForDate(): __PublicMethodMetaInfo<
  'GET',
  { operationId: string },
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.CalculateAvailableTimeSlotsForDateRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.CalculateAvailableTimeSlotsForDateRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.CalculateAvailableTimeSlotsForDateResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.CalculateAvailableTimeSlotsForDateResponse
> {
  const payload = { operationId: ':operationId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.calculateAvailableTimeSlotsForDate(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/operations/{operationId}/available-time-slots-per-date',
    pathParams: { operationId: 'operationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listAvailableDatesInRange(): __PublicMethodMetaInfo<
  'GET',
  { operationId: string },
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.ListAvailableDatesInRangeRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.ListAvailableDatesInRangeRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.ListAvailableDatesInRangeResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.ListAvailableDatesInRangeResponse
> {
  const payload = { operationId: ':operationId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.listAvailableDatesInRange(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/operations/{operationId}/available-dates-in-range',
    pathParams: { operationId: 'operationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function calculateAvailableDatesInRange(): __PublicMethodMetaInfo<
  'GET',
  { operationId: string },
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.CalculateAvailableDatesInRangeRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.CalculateAvailableDatesInRangeRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.CalculateAvailableDatesInRangeResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.CalculateAvailableDatesInRangeResponse
> {
  const payload = { operationId: ':operationId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.calculateAvailableDatesInRange(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/operations/{operationId}/available-dates',
    pathParams: { operationId: 'operationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function validateOperationAddress(): __PublicMethodMetaInfo<
  'GET',
  { operationId: string },
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.ValidateOperationAddressRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.ValidateOperationAddressRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.ValidateOperationAddressResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.ValidateOperationAddressResponse
> {
  const payload = { operationId: ':operationId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.validateOperationAddress(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/operations/{operationId}/validate-address',
    pathParams: { operationId: 'operationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateOperationTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.BulkUpdateOperationTagsRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.BulkUpdateOperationTagsRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.BulkUpdateOperationTagsResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.BulkUpdateOperationTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.bulkUpdateOperationTags(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/operations/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateOperationTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.BulkUpdateOperationTagsByFilterRequest,
  ambassadorWixRestaurantsOperationsV1OperationTypes.BulkUpdateOperationTagsByFilterRequest,
  ambassadorWixRestaurantsOperationsV1OperationUniversalTypes.BulkUpdateOperationTagsByFilterResponse,
  ambassadorWixRestaurantsOperationsV1OperationTypes.BulkUpdateOperationTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOperationsV1Operation.bulkUpdateOperationTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/operations/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Operation as OperationOriginal,
  OperationOnlineOrderingStatusOptionsOneOf as OperationOnlineOrderingStatusOptionsOneOfOriginal,
  Scheduling as SchedulingOriginal,
  SchedulingSchedulingOptionsOneOf as SchedulingSchedulingOptionsOneOfOriginal,
  SchedulingType as SchedulingTypeOriginal,
  SchedulingTypeWithLiterals as SchedulingTypeWithLiteralsOriginal,
  AsapScheduling as AsapSchedulingOriginal,
  AsapSchedulingPreparationTimeOneOf as AsapSchedulingPreparationTimeOneOfOriginal,
  AsapSchedulingAsapPreorderOneOf as AsapSchedulingAsapPreorderOneOfOriginal,
  PreparationTimeType as PreparationTimeTypeOriginal,
  PreparationTimeTypeWithLiterals as PreparationTimeTypeWithLiteralsOriginal,
  TimeDuration as TimeDurationOriginal,
  TimeUnit as TimeUnitOriginal,
  TimeUnitWithLiterals as TimeUnitWithLiteralsOriginal,
  TimeDurationRange as TimeDurationRangeOriginal,
  AsapPreorderType as AsapPreorderTypeOriginal,
  AsapPreorderTypeWithLiterals as AsapPreorderTypeWithLiteralsOriginal,
  BusinessDaysPreorder as BusinessDaysPreorderOriginal,
  AsapOrderPacing as AsapOrderPacingOriginal,
  AsapOrderPacingPacingAvailabilityOneOf as AsapOrderPacingPacingAvailabilityOneOfOriginal,
  AsapPacingWindowType as AsapPacingWindowTypeOriginal,
  AsapPacingWindowTypeWithLiterals as AsapPacingWindowTypeWithLiteralsOriginal,
  ActivationType as ActivationTypeOriginal,
  ActivationTypeWithLiterals as ActivationTypeWithLiteralsOriginal,
  WeeklyActivePeriods as WeeklyActivePeriodsOriginal,
  ActivePeriod as ActivePeriodOriginal,
  EntitiesDayOfWeek as EntitiesDayOfWeekOriginal,
  EntitiesDayOfWeekWithLiterals as EntitiesDayOfWeekWithLiteralsOriginal,
  TimeOfDayRange as TimeOfDayRangeOriginal,
  TimeOfDay as TimeOfDayOriginal,
  PreorderScheduling as PreorderSchedulingOriginal,
  PreorderMethod as PreorderMethodOriginal,
  PreorderMethodMethodOptionsOneOf as PreorderMethodMethodOptionsOneOfOriginal,
  DayAndTime as DayAndTimeOriginal,
  MethodType as MethodTypeOriginal,
  MethodTypeWithLiterals as MethodTypeWithLiteralsOriginal,
  TimeBounded as TimeBoundedOriginal,
  WeeklySchedule as WeeklyScheduleOriginal,
  FulfillmentTimesDisplayConfig as FulfillmentTimesDisplayConfigOriginal,
  FulfillmentTimesDisplayConfigFulfillmentTimesDisplayOptionsOneOf as FulfillmentTimesDisplayConfigFulfillmentTimesDisplayOptionsOneOfOriginal,
  FulfillmentTimesType as FulfillmentTimesTypeOriginal,
  FulfillmentTimesTypeWithLiterals as FulfillmentTimesTypeWithLiteralsOriginal,
  PreOrderPacing as PreOrderPacingOriginal,
  PreOrderPacingPacingAvailabilityOneOf as PreOrderPacingPacingAvailabilityOneOfOriginal,
  PreorderPacingWindowType as PreorderPacingWindowTypeOriginal,
  PreorderPacingWindowTypeWithLiterals as PreorderPacingWindowTypeWithLiteralsOriginal,
  WeeklyActiveDays as WeeklyActiveDaysOriginal,
  OnlineOrderingStatusType as OnlineOrderingStatusTypeOriginal,
  OnlineOrderingStatusTypeWithLiterals as OnlineOrderingStatusTypeWithLiteralsOriginal,
  OnlineOrderingPausedUntilOptions as OnlineOrderingPausedUntilOptionsOriginal,
  FulfillmentType as FulfillmentTypeOriginal,
  FulfillmentTypeWithLiterals as FulfillmentTypeWithLiteralsOriginal,
  OrderScheduling as OrderSchedulingOriginal,
  OrderSchedulingOrderSchedulingOptionsOneOf as OrderSchedulingOrderSchedulingOptionsOneOfOriginal,
  AsapOrderScheduling as AsapOrderSchedulingOriginal,
  AsapOrderSchedulingAsapFutureHandlingOptionsOneOf as AsapOrderSchedulingAsapFutureHandlingOptionsOneOfOriginal,
  PreparationTime as PreparationTimeOriginal,
  PreparationTimeTimeSpecificationOneOf as PreparationTimeTimeSpecificationOneOfOriginal,
  PreparationTimePreparationTimeType as PreparationTimePreparationTimeTypeOriginal,
  PreparationTimePreparationTimeTypeWithLiterals as PreparationTimePreparationTimeTypeWithLiteralsOriginal,
  AsapFutureHandlingType as AsapFutureHandlingTypeOriginal,
  AsapFutureHandlingTypeWithLiterals as AsapFutureHandlingTypeWithLiteralsOriginal,
  BusinessDaysAheadHandling as BusinessDaysAheadHandlingOriginal,
  BusinessLocationDetails as BusinessLocationDetailsOriginal,
  V1Address as V1AddressOriginal,
  V1StreetAddress as V1StreetAddressOriginal,
  V1AddressLocation as V1AddressLocationOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  ListBlockedPeriodsRequest as ListBlockedPeriodsRequestOriginal,
  ListBlockedPeriodsResponse as ListBlockedPeriodsResponseOriginal,
  BlockedPeriod as BlockedPeriodOriginal,
  ListOrdersForOperationRequest as ListOrdersForOperationRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListOrdersForOperationResponse as ListOrdersForOperationResponseOriginal,
  PacingOrder as PacingOrderOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  DeliveryProfileConfiguredForOperation as DeliveryProfileConfiguredForOperationOriginal,
  OperationsDataCloningCompleted as OperationsDataCloningCompletedOriginal,
  GetOperationRequest as GetOperationRequestOriginal,
  GetOperationResponse as GetOperationResponseOriginal,
  UpdateOperationRequest as UpdateOperationRequestOriginal,
  UpdateOperationResponse as UpdateOperationResponseOriginal,
  DeleteOperationRequest as DeleteOperationRequestOriginal,
  DeleteOperationResponse as DeleteOperationResponseOriginal,
  QueryOperationRequest as QueryOperationRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CommonCursorPaging as CommonCursorPagingOriginal,
  QueryOperationResponse as QueryOperationResponseOriginal,
  CommonCursorPagingMetadata as CommonCursorPagingMetadataOriginal,
  CommonCursors as CommonCursorsOriginal,
  ListOperationsRequest as ListOperationsRequestOriginal,
  ListOperationsResponse as ListOperationsResponseOriginal,
  ListOperationIdsRequest as ListOperationIdsRequestOriginal,
  ListOperationIdsResponse as ListOperationIdsResponseOriginal,
  ListOperationsInternalRequest as ListOperationsInternalRequestOriginal,
  ListOperationsInternalResponse as ListOperationsInternalResponseOriginal,
  ListAvailableFulfillmentOptionsRequest as ListAvailableFulfillmentOptionsRequestOriginal,
  CommonAddress as CommonAddressOriginal,
  CommonAddressStreetOneOf as CommonAddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  ListAvailableFulfillmentOptionsResponse as ListAvailableFulfillmentOptionsResponseOriginal,
  FulfillmentOption as FulfillmentOptionOriginal,
  FulfillmentOptionFulfillmentTimeOptionsOneOf as FulfillmentOptionFulfillmentTimeOptionsOneOfOriginal,
  FulfillmentOptionFulfillmentTimesDisplayOptionsOneOf as FulfillmentOptionFulfillmentTimesDisplayOptionsOneOfOriginal,
  FulfillmentOptionFulfillmentTypeOptionsOneOf as FulfillmentOptionFulfillmentTypeOptionsOneOfOriginal,
  FulfillmentOptionAvailability as FulfillmentOptionAvailabilityOriginal,
  DayOfWeekAvailability as DayOfWeekAvailabilityOriginal,
  AvailabilityException as AvailabilityExceptionOriginal,
  FulfillmentTimeType as FulfillmentTimeTypeOriginal,
  FulfillmentTimeTypeWithLiterals as FulfillmentTimeTypeWithLiteralsOriginal,
  DurationRange as DurationRangeOriginal,
  FulfillmentTimesDisplayType as FulfillmentTimesDisplayTypeOriginal,
  FulfillmentTimesDisplayTypeWithLiterals as FulfillmentTimesDisplayTypeWithLiteralsOriginal,
  TimeWindowDisplayConfig as TimeWindowDisplayConfigOriginal,
  PickupDetails as PickupDetailsOriginal,
  DeliveryDetails as DeliveryDetailsOriginal,
  DineInDetails as DineInDetailsOriginal,
  ListFirstAvailableTimeSlotForFulfillmentTypesRequest as ListFirstAvailableTimeSlotForFulfillmentTypesRequestOriginal,
  ListFirstAvailableTimeSlotForFulfillmentTypesResponse as ListFirstAvailableTimeSlotForFulfillmentTypesResponseOriginal,
  FulfillmentTimeSlot as FulfillmentTimeSlotOriginal,
  TimeSlotStatus as TimeSlotStatusOriginal,
  TimeSlotStatusWithLiterals as TimeSlotStatusWithLiteralsOriginal,
  FulfillmentDetails as FulfillmentDetailsOriginal,
  FulfillmentDetailsFulfillmentTimeOptionsOneOf as FulfillmentDetailsFulfillmentTimeOptionsOneOfOriginal,
  FulfillmentAddress as FulfillmentAddressOriginal,
  CalculateFirstAvailableTimeSlotPerFulfillmentTypeRequest as CalculateFirstAvailableTimeSlotPerFulfillmentTypeRequestOriginal,
  CalculateFirstAvailableTimeSlotPerFulfillmentTypeResponse as CalculateFirstAvailableTimeSlotPerFulfillmentTypeResponseOriginal,
  TimeSlotForFulfillment as TimeSlotForFulfillmentOriginal,
  TimeSlot as TimeSlotOriginal,
  OrderSchedulingType as OrderSchedulingTypeOriginal,
  OrderSchedulingTypeWithLiterals as OrderSchedulingTypeWithLiteralsOriginal,
  TimeSlotForFulfillmentTimeSlotStatus as TimeSlotForFulfillmentTimeSlotStatusOriginal,
  TimeSlotForFulfillmentTimeSlotStatusWithLiterals as TimeSlotForFulfillmentTimeSlotStatusWithLiteralsOriginal,
  FulfillmentInfo as FulfillmentInfoOriginal,
  FulfillmentInfoFulfillmentTimeOneOf as FulfillmentInfoFulfillmentTimeOneOfOriginal,
  ListFirstAvailableTimeSlotsForOperationsRequest as ListFirstAvailableTimeSlotsForOperationsRequestOriginal,
  ListFirstAvailableTimeSlotsForOperationsResponse as ListFirstAvailableTimeSlotsForOperationsResponseOriginal,
  OperationTimeSlot as OperationTimeSlotOriginal,
  CalculateFirstAvailableTimeSlotsPerOperationRequest as CalculateFirstAvailableTimeSlotsPerOperationRequestOriginal,
  CalculateFirstAvailableTimeSlotsPerOperationResponse as CalculateFirstAvailableTimeSlotsPerOperationResponseOriginal,
  TimeSlotForOperation as TimeSlotForOperationOriginal,
  ListFirstAvailableTimeSlotsForMenusRequest as ListFirstAvailableTimeSlotsForMenusRequestOriginal,
  ListFirstAvailableTimeSlotsForMenusResponse as ListFirstAvailableTimeSlotsForMenusResponseOriginal,
  FirstFulfillmentTimeSlotsPerMenu as FirstFulfillmentTimeSlotsPerMenuOriginal,
  CalculateFirstAvailableTimeSlotsPerMenuRequest as CalculateFirstAvailableTimeSlotsPerMenuRequestOriginal,
  CalculateFirstAvailableTimeSlotsPerMenuResponse as CalculateFirstAvailableTimeSlotsPerMenuResponseOriginal,
  FulfillmentTimeSlotsPerMenu as FulfillmentTimeSlotsPerMenuOriginal,
  PagingMetadata as PagingMetadataOriginal,
  CalculateFirstAvailableTimeSlotsForItemRequest as CalculateFirstAvailableTimeSlotsForItemRequestOriginal,
  CalculateFirstAvailableTimeSlotsForItemResponse as CalculateFirstAvailableTimeSlotsForItemResponseOriginal,
  ListAvailableTimeSlotsForDateRequest as ListAvailableTimeSlotsForDateRequestOriginal,
  _Date as _DateOriginal,
  ListAvailableTimeSlotsForDateResponse as ListAvailableTimeSlotsForDateResponseOriginal,
  CalculateAvailableTimeSlotsForDateRequest as CalculateAvailableTimeSlotsForDateRequestOriginal,
  CalculateAvailableTimeSlotsForDateResponse as CalculateAvailableTimeSlotsForDateResponseOriginal,
  ListAvailableDatesInRangeRequest as ListAvailableDatesInRangeRequestOriginal,
  ListAvailableDatesInRangeResponse as ListAvailableDatesInRangeResponseOriginal,
  FulfillmentTypeAvailableDates as FulfillmentTypeAvailableDatesOriginal,
  CalculateAvailableDatesInRangeRequest as CalculateAvailableDatesInRangeRequestOriginal,
  CalculateAvailableDatesInRangeResponse as CalculateAvailableDatesInRangeResponseOriginal,
  GetExpectedFulfillmentSelectionRequest as GetExpectedFulfillmentSelectionRequestOriginal,
  GetExpectedFulfillmentSelectionResponse as GetExpectedFulfillmentSelectionResponseOriginal,
  UpdateImmutableFieldsRequest as UpdateImmutableFieldsRequestOriginal,
  ImmutableFields as ImmutableFieldsOriginal,
  UpdateImmutableFieldsResponse as UpdateImmutableFieldsResponseOriginal,
  ValidateOperationAddressRequest as ValidateOperationAddressRequestOriginal,
  ValidateOperationAddressResponse as ValidateOperationAddressResponseOriginal,
  AddressViolation as AddressViolationOriginal,
  ViolationType as ViolationTypeOriginal,
  ViolationTypeWithLiterals as ViolationTypeWithLiteralsOriginal,
  UpdateDeliveryRegionsRequest as UpdateDeliveryRegionsRequestOriginal,
  UpdateDeliveryRegionsResponse as UpdateDeliveryRegionsResponseOriginal,
  BulkUpdateOperationTagsRequest as BulkUpdateOperationTagsRequestOriginal,
  BulkUpdateOperationTagsResponse as BulkUpdateOperationTagsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkUpdateOperationTagsResult as BulkUpdateOperationTagsResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateOperationTagsByFilterRequest as BulkUpdateOperationTagsByFilterRequestOriginal,
  BulkUpdateOperationTagsByFilterResponse as BulkUpdateOperationTagsByFilterResponseOriginal,
  SitePropertiesNotification as SitePropertiesNotificationOriginal,
  SitePropertiesEvent as SitePropertiesEventOriginal,
  Properties as PropertiesOriginal,
  Categories as CategoriesOriginal,
  Locale as LocaleOriginal,
  Address as AddressOriginal,
  AddressHint as AddressHintOriginal,
  PlacementType as PlacementTypeOriginal,
  PlacementTypeWithLiterals as PlacementTypeWithLiteralsOriginal,
  GeoCoordinates as GeoCoordinatesOriginal,
  BusinessSchedule as BusinessScheduleOriginal,
  TimePeriod as TimePeriodOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  SpecialHourPeriod as SpecialHourPeriodOriginal,
  Multilingual as MultilingualOriginal,
  SupportedLanguage as SupportedLanguageOriginal,
  ResolutionMethod as ResolutionMethodOriginal,
  ResolutionMethodWithLiterals as ResolutionMethodWithLiteralsOriginal,
  ConsentPolicy as ConsentPolicyOriginal,
  Translation as TranslationOriginal,
  ChangeContext as ChangeContextOriginal,
  ChangeContextPayloadOneOf as ChangeContextPayloadOneOfOriginal,
  PropertiesChange as PropertiesChangeOriginal,
  V4SiteCreated as V4SiteCreatedOriginal,
  SiteCloned as SiteClonedOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  BulkUpdateOperationTagsApplicationErrors as BulkUpdateOperationTagsApplicationErrorsOriginal,
  BulkUpdateOperationTagsByFilterApplicationErrors as BulkUpdateOperationTagsByFilterApplicationErrorsOriginal,
} from './restaurants-operations-v1-operation-operations.types.js';
